import { IS_DIBREWORK, IS_KESIA } from "../lib/theme";

const BASE = import.meta.env.BASE_URL;

/**
 * Brand lockup, theme-aware. Dibrework theme → the cup logo (horizontal in the
 * chrome, full on login); default theme → the "AI Marketing." text wordmark.
 *
 *  - sidebar : admin Console sidebar (light bg)
 *  - header  : brand Workspace top bar (dark bg → light logo)
 *  - login   : login card (light bg, large)
 */
export function Brandmark({ variant }: { variant: "sidebar" | "header" | "login" }) {
  if (IS_KESIA) {
    const src =
      variant === "header"
        ? `${BASE}kesia-logo-white.png`
        : `${BASE}kesia-logo-color.png`;
    const cls =
      variant === "login"
        ? "mx-auto h-16 w-auto"
        : variant === "header"
          ? "h-8 w-auto shrink-0"
          : "h-9 w-auto";
    return <img src={src} alt="Kesia Marketing" className={cls} />;
  }
  if (IS_DIBREWORK) {
    if (variant === "login") {
      return (
        <img
          src={`${BASE}dibrework-logo.svg`}
          alt="dibrework"
          className="mx-auto h-20 w-auto"
        />
      );
    }
    if (variant === "header") {
      return (
        <img
          src={`${BASE}dibrework-horizontal-light.svg`}
          alt="dibrework"
          className="h-8 w-auto shrink-0"
        />
      );
    }
    return (
      <img
        src={`${BASE}dibrework-horizontal.svg`}
        alt="dibrework"
        className="h-9 w-auto"
      />
    );
  }

  // Default theme — text wordmark.
  const dot = <span className="text-teal">.</span>;
  if (variant === "login") {
    return (
      <div className="mb-1 text-2xl font-extrabold tracking-tight text-navy">
        AI Marketing{dot}
      </div>
    );
  }
  if (variant === "header") {
    return (
      <span className="shrink-0 whitespace-nowrap text-lg font-extrabold tracking-tight text-white">
        AI Marketing{dot}
      </span>
    );
  }
  return (
    <span className="text-lg font-extrabold tracking-tight text-navy">
      AI Marketing{dot}
    </span>
  );
}
